/**
 * Page Designer Search — server metadata and server-side search.
 *
 * The browser never names a table or a column of its own. It asks the server
 * which data sources exist, which fields of the chosen source are searchable,
 * and then asks the server to run the search. Authorization, organization
 * scope and the result cap all stay on the server.
 */

import { api } from "@/lib/orgApi";

const BASE = "/page-designer";

export function fetchSearchDataSources() {
  return api.get(`${BASE}/data-sources`).then((response) => response.data || {});
}

export function fetchSearchSourceFields(sourceId) {
  return api
    .get(`${BASE}/data-sources/${encodeURIComponent(sourceId)}/fields`)
    .then((response) => response.data || {});
}

/**
 * Field ids travel as one comma-separated value. The server splits them and
 * checks every id against the selected source's allowlist.
 */
export function runSearchQuery({ sourceId, fields, query, maxResults }) {
  const selected = (fields || []).join(",");
  return api
    .get(`${BASE}/search`, {
      params: {
        sourceId,
        q: query || "",
        fields: selected || undefined,
        maxResults,
      },
    })
    .then((response) => response.data || {});
}
